import React, { Fragment } from 'react';
import { Grid, Icon } from '@material-ui/core';
import moment from 'moment';


const SegmentTitle = ({ index, segmentsLength, segment, selectedidPrice }) => {

    const { origin, destination, departure } = segment.dictionary.leg

    let haveNoResults = segment.highlights ? false : true;

    const NoResults = () => {
        return (
            <div className='message-no-results'>NO SE ENCONTRARON RESULTADOS PARA ESTE TRAMO</div>
        );
    }

    // const selected = true
    return (
        <Fragment>
            {selectedidPrice}
            <div className={`tab-title-content ${selectedidPrice && 'segment-selected'}  ${haveNoResults ? 'no-results' : ''}  `} >
                {/* <div className="line-top"></div> */}
                <div className="inner-content">

                    {selectedidPrice ?
                        <span className="selected-ok">
                            <Icon>check_circle_outline</Icon>
                        </span>
                        :
                        <Fragment>
                            {/* <span className="selected-arrow">
                            <Icon>arrow_circle_up</Icon> {index + 1}
                        </span> */}

                            <span className="nro-tramo-tab">{index + 1}</span>
                        </Fragment>

                    }
                    <div className="icon-tab-title d-none d-md-block">
                        <div className="icon-content"><Icon className="train">train</Icon></div>
                        <div className="icon-content"><Icon className="circle">circle</Icon></div>
                        <div className="icon-content"><Icon className="circle">circle</Icon></div>
                        <div className="icon-content"><Icon className="place">place</Icon></div>
                    </div>

                    <div className={`tab-title ${segmentsLength === 2 ? 'tab-title-2' : ''} ${segmentsLength === 3 ? 'tab-title-3' : ''} ${segmentsLength === 4 ? 'tab-title-4' : ''}`} >
                        {segmentsLength > 3 ? (
                            <div>
                                <h4 className="title">
                                    <span className="origin" > {origin.localLabel} </span>
                                </h4>
                                <h4 className="title">
                                    <span className="destination" > {destination.localLabel} </span>
                                </h4>
                                {haveNoResults
                                    ? <NoResults />
                                    : <p class="date"><Icon>date_range</Icon> {moment(departure).locale('es').format('dddd, Do MMM YY')} <span class="year"></span></p>
                                }
                            </div>
                        ) : (
                            <Grid container>
                                <Grid item md={6} >
                                    <h4 className="title">
                                        <span className="origin" > {origin.localLabel} </span>
                                    </h4>
                                    <h4 className="title">
                                        <span className="destination" > {destination.localLabel} </span>
                                    </h4>
                                </Grid>
                                <Grid item md={6}>
                                    {haveNoResults
                                        ? <NoResults />
                                        : <p className="date"><Icon>date_range</Icon> {moment(departure).locale('es').format('dddd, Do MMM YY')} <span className="year"></span></p>
                                    }
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    )
};


export default SegmentTitle;